import { gql } from "@apollo/client"

export const CreateQuizQuestion = gql`
  mutation createQuizQuestion($data: quizQuestionsInput) {
    createQuizQuestion(data: $data) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`

export const getQuizQuestionsQuery = gql`
  query getQuizQuestions(
    $quizId: Int
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllQuizQuestions(
      quizId: $quizId
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        question
        questionType
        image_url
        video_id
        number
      }
      pagination {
        pageNumber
        pageLimit
        totalCount
      }
    }
  }
`
export const deleteQuizQuestionMutation = gql`
  mutation deleteQuizQuestion($id: Int!) {
    deleteQuizQuestion(id: $id) {
      id
      status
      error {
        message
      }
    }
  }
`
export const getOneQuizQuestionQuery = gql`
  query getQuizQuestion($id: Int!) {
    getOneQuizQuestion(id: $id) {
      id
      quizMasterId
      question
      error {
        statusCode
        message
      }
    }
  }
`
export const createQuizQuestionMutation = gql`
  mutation createQuizQuestion($data: quizQuestionsInput) {
    createQuizQuestion(data: $data) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`
export const updateQuizQuestionMutation = gql`
  mutation updateQuizQuestion($id: Int!, $data: quizQuestionsInput) {
    updateQuizQuestion(id: $id, data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`
export const getAllAgeGroup = gql`
  query getAgeGroups(
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllAgeGroupMasters(
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        ageGroupTitle
      }
    }
  }
`
export const fileUploadQuery = gql`
  query getUploadUrl($type: String!, $fileName: String!) {
    getUploadUrl(type: $type, fileName: $fileName) {
      status

      url

      error {
        message
      }
    }
  }
`
